import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Layout.css';
import logo from '../public/logo.png';
const menuItems = [
  { path: '/admin/dashboard',    label: 'Dashboard',      icon: '▦',  perm: 'dashboard.view' },
  { path: '/admin/events',       label: 'Events',         icon: '📅', perm: 'events.view' },
  { path: '/admin/registrants',  label: 'Registrants',    icon: '👥', perm: 'registrants.view' },
  { path: '/admin/transactions', label: 'Transactions',   icon: '💳', perm: 'transactions.view' },
  { path: '/admin/broadcast',    label: 'Broadcast',      icon: '📢', perm: 'broadcast.send' },
  { path: '/admin/roles',        label: 'Roles',          icon: '🔐', perm: 'roles.view' },
  { path: '/admin/users',        label: 'Admin Users',    icon: '⚙',  perm: 'admin_users.view' },
  { path: '/admin/config',       label: 'Configuration',  icon: '🔧', perm: 'config.view' },
];

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { user, logout, hasPermission } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/admin/login'); };
  const visibleItems = menuItems.filter(m => !m.perm || hasPermission(m.perm));

  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="sidebar-brand">
          {/* <div className="brand-logo">E</div> */}
          <img src={logo} alt="EventHub Logo" className="brand-logo" />
                    <span className="brand-name">AI<span> World Community</span></span>
        </div>

        <nav className="sidebar-nav">
          {visibleItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <a className="nav-item" href="/" target="_blank" rel="noreferrer">
            <span className="nav-icon">🌐</span>
            <span className="nav-label">View Website</span>
          </a>
        </div>
      </aside>

      {/* Main content */}
      <div className="admin-main">
        {/* Header */}
        <header className="admin-header">
          <button className="menu-toggle" onClick={() => setSidebarOpen(p => !p)} title="Toggle sidebar">
            <span/>
            <span/>
            <span/>
          </button>
          <div className="header-spacer"/>
          <div className="header-actions">
            <div className="user-menu">
              <div className="user-avatar">{user?.firstname?.[0]}{user?.lastname?.[0]}</div>
              <div className="user-info">
                <span className="user-name">{user?.firstname} {user?.lastname}</span>
                <span className="user-role">{user?.role}</span>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={handleLogout}>Sign out</button>
            </div>
          </div>
        </header>

        {/* Page content */}
        <main className="admin-content">
          {children}
        </main>
      </div>

      {/* Mobile overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}/>}
    </div>
  );
};

export default Layout;
